<template>
  <b-modal :id="id" :cancel-title="$t('_cancel')" ref="cancel"
           @ok="ok" @cancel="cancel" :modal-class="modalClass"
  >
    <frontoffice-loader v-if="isLoading" />

    <select-input v-else name="cancellation-reasons"
                  :label="$t('booking.cancel.question')"
                  :placeholder="$t('booking.cancel.placeholder')"
                  :options="cancellationReasons"
                  @selected="selected"
                  :required="false"
    />

    <b-alert v-if="displayError && !isLoading" variant="danger" show class="col-12">
      {{ $t(errorMessage) }}
    </b-alert>
  </b-modal>
</template>

<script>
import selectInput from '@/components/frontoffice/form/baseInput/select'
import modalMixin from '@/components/frontoffice/Booking/modal/mixin'
import frontofficeLoader from '@/components/frontoffice/loader'
import loadingModalMixin from'@/components/frontoffice/mixins/loadingModal'


export default {
  name: 'booking-modal-cancel',

  components: {
    selectInput,
    frontofficeLoader
  },

  mixins: [modalMixin, loadingModalMixin],

  props: {
    id: {
      type: String,
      default: "cancel"
    },
    isOnline: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      errorMessage: 'booking.cancel.error',
      submitterInfos: {
        type: this.$route.name === 'public_booking_show' ? 'public_booking_cancel' : 'booking_cancel',
        values: {
          cancellation_comment: null
        }
      },
      displayError: false,
      closeAfterServerResponse: true
    }
  },

  methods: {
    selected (option) {
      this.submitterInfos.values.cancellation_comment = option ? option.text : option
    },

    ok (event) {
      if (!this.submitterInfos.values.cancellation_comment) {
        event.preventDefault()
        this.displayError = true
      } else {
        if (this.isOnline) {
          event.preventDefault()
          this.isLoading = true
        }
        this.confirm()
      }
    }
  },

  computed: {
    successMessage () {
      return this.isOnline
        ? 'booking.cancel.success_online'
        : 'booking.cancel.success'
    }
  }
}
</script>
